import { render, staticRenderFns } from "./SiteDepotStock.vue?vue&type=template&id=1ac23488&"
import script from "./SiteDepotStock.vue?vue&type=script&lang=js&"
export * from "./SiteDepotStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ac23488')) {
      api.createRecord('1ac23488', component.options)
    } else {
      api.reload('1ac23488', component.options)
    }
    module.hot.accept("./SiteDepotStock.vue?vue&type=template&id=1ac23488&", function () {
      api.rerender('1ac23488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Editor/Aggregation/SiteDepotStock.vue"
export default component.exports